// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import OnlinePaymentTransactionUpdatedModel from '../../model/online-payment-transaction-updated-model';
import OnlinePaymentTransactionUpdatedDTO from '../dto/online-payment-transaction-updated-dto';
import dtoSchema from '../schemas/online-payment-transaction-updated-schema';

export default abstract class OnlinePaymentTransactionUpdatedModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<OnlinePaymentTransactionUpdatedDTO>) {
    super();
    if (data) {
      this.id = data.id ?? undefined;
    }
  }
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<OnlinePaymentTransactionUpdatedDTO>): OnlinePaymentTransactionUpdatedModel;
  static toModel(dto: DeepPartial<OnlinePaymentTransactionUpdatedDTO> | undefined | null): OnlinePaymentTransactionUpdatedModel | undefined;
  static toModel(dto: DeepPartial<OnlinePaymentTransactionUpdatedDTO> | undefined | null): OnlinePaymentTransactionUpdatedModel | undefined {
    return dto ? new OnlinePaymentTransactionUpdatedModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<OnlinePaymentTransactionUpdatedModel> | OnlinePaymentTransactionUpdatedModel): OnlinePaymentTransactionUpdatedDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as OnlinePaymentTransactionUpdatedDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for OnlinePaymentTransactionUpdatedModel, can not map to OnlinePaymentTransactionUpdatedDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
